/*global $, document, window, setTimeout, alert, FG, confirm, location, FGT_CONFIG, console*/
(function () {
    'use strict';

    window.FG.Base = {
        /**
         * Root URL for the label
         * @param {String}
         */
        labelRoot: null,

        /**
         * What environment are we in, i.e. dev/prod
         * @param {String}
         */
        environment: null,

        init: function () {
            this.labelRoot = $('link[rel="label_root"]').attr('href');

            this.environment = FGT_CONFIG;

            FG.Utils.init();

            FG.User.init();

            $('.close-cb').on('click', function (e) {
                e._preventClickEvent();

                e.preventDefault();
            });

            this.bindToSignInLink();

            this.initMobileNav();

            this.cartTotal();

            this.activateCartTimer();

            this.waitlist();

            this.a11yFunctions();

            this.captureDatastreamData();
        },

        activateCartTimer: function () {
            var db = new FG.DB();

            var renewalCartExpiry = $.cookie('cartExpiry');
            if (renewalCartExpiry) {
                db.set('cartActive', 1);
                db.set(
                    'cartExpiry',
                    parseInt(renewalCartExpiry) + FG.Base.getCurrentTimestamp()
                );
                $.removeCookie('cartExpiry');
            }

            FG.CartTimer.init();
        },

        waitlist: function () {
            var db = new FG.DB();

            var renewalActiveWaitlistRequest = $.cookie(
                'activeWaitlistRequest'
            );
            if (renewalActiveWaitlistRequest) {
                db.set('activeWaitlistRequest', renewalActiveWaitlistRequest);
                $.removeCookie('activeWaitlistRequest');
            }

            var activeWaitlistRequest = db.get('activeWaitlistRequest');
            if (activeWaitlistRequest == true || activeWaitlistRequest == 1) {
                $('#menu-waitlist').parent().removeClass('hide');
            }
        },

        cartTotal: function () {
            var db = new FG.DB();

            var renewalTotalCount = $.cookie('totalCount');
            if (renewalTotalCount) {
                db.set('totalCount', renewalTotalCount);
                $.removeCookie('totalCount');
            }

            var totalCount = db.get('totalCount');

            var $cartBadge = $('.cart-badge');
            if (totalCount) {
                $cartBadge.text(totalCount);
            } else {
                $cartBadge.text('0');
            }

            if (totalCount && totalCount > 9) {
                $cartBadge.css({ 'border-radius': '25px', padding: '1px 6px' });
            } else {
                $cartBadge.css({
                    'border-radius': '50%',
                    padding: '0',
                    'min-width': '22px',
                    'line-height': '22px',
                });
            }
        },

        initMobileNav: function () {
            $('#navToggle').on('click', function (e) {
                var $menuIcon = $('#menu-icon');
                if ($('#topNav').is(':visible')) {
                    $menuIcon.removeClass('menu-close').addClass('menu');
                } else {
                    $menuIcon.removeClass('menu').addClass('menu-close');
                }
                if (e.type == 'click' || e.which == '13' || e.which == '32') {
                    e.preventDefault();
                    $('#topNav').slideToggle('fast');
                    return false;
                }
            });
        },

        /**
         * Bind to the sign in link in the menu
         */
        bindToSignInLink: function () {
            $('#link-global-signin').on('click', function (e) {
                $('#modal-signin')
                    .modal({
                        show: true,
                        backdrop: true,
                        keyboard: true,
                    })
                    .on('hide', function () {
                        return !FG.AjaxJob.inJob;
                    });

                $('#guest-checkout-container').addClass('hide');

                e.preventDefault();

                return false;
            });
        },
        /*
         *Misc aiiy functions needed for pages
         */
        a11yFunctions: function () {
            $(document).on('click', '.qty-btn', function () {
                $(this).parent('div.packageQuantity').submit();
            });
            $(document).on(
                'keyup',
                '[role="checkbox"], #btn-cvc-help, a.clearCart',
                function (e) {
                    if (e.which == '32') {
                        e.preventDefault();
                        e.stopPropagation();
                        $(this).click();
                    }
                }
            );
            $(document).on(
                'keyup',
                'a.manage-order, a.sign-in, #personalization_expanded_button, .qty-btn',
                function (e) {
                    if (e.which == '32' || e.which == '13') {
                        e.preventDefault();
                        e.stopPropagation();
                        $(this).click();
                    }
                }
            );

            $(document).on(
                'shown.bs.tab',
                'a[data-toggle="tab"]',
                function (e) {
                    $(this).attr('aria-selected', 'true');
                    $('a[data-toggle="tab"]')
                        .not($(this))
                        .attr('aria-selected', 'false');
                }
            );

            $(document).on('keyup', 'a[data-toggle="tab"]', function (e) {
                var $this = $(e.target);
                var numTabs = $this
                    .parent('[role="tablist"]')
                    .find('[data-toggle="tab"]').length;
                var $thiseEQ = $this.index();
                switch (e.which) {
                    case '37':
                    case '38':
                        e.preventDefault();
                        e.stopPropagation();
                        var moveNum = $thisEQ + 1 > numTabs ? 0 : $thisEQ + 1;
                        $this.parent().siblings().eq(moveNum).focus();
                        break;
                    case '39':
                    case '40':
                        e.preventDefault();
                        e.stopPropagation();
                        e.preventDefault();
                        e.stopPropagation();
                        var moveNum =
                            $thisEQ - 1 < 0 ? numTabs - 1 : $thisEQ - 1;
                        $this.parent().siblings().eq(moveNum).focus();
                        break;
                }
            });

            $('form')
                .find('.required')
                .each(function (e) {
                    var $thisId = $(this).attr('id');
                    $(this).attr('aria-required', true);
                });
        },

        /**
         * Initialize validation on any form.
         * @param {string}  domID  DOM ID of the form
         */
        initValidateForm: function (Form) {
            Form.find('.required:visible').each(function () {
                var id = this.id;
                var $this = $(this);

                $this.unbind('blur').bind('blur', function () {
                    if (!$this.val()) {
                        $this.addClass('invalid');
                        Form.find('label[for="' + id + '"]').addClass(
                            'invalid'
                        );
                        $this.parent().addClass('invalid');

                        $this.attr('aria-describedby', id + '-error-msg');
                        // Hide all error messages for the input to only show the required message
                        $('[id^=' + id + '-error-msg]').addClass('hide');
                        $('#' + id + '-error-msg').addClass('invalid').removeClass('hide');
                    } else {
                        $this.removeClass('invalid');
                        Form.find('label[for="' + id + '"]').removeClass(
                            'invalid'
                        );
                        $this.parent().removeClass('invalid');
                        $('#' + id + '-error-msg').addClass('hide');
                        $this.attr('aria-describedby', '');
                    }
                });

                //for text input
                $this.keyup(function () {
                    $this.removeClass('invalid');
                    $('label[for="' + id + '"]').removeClass('invalid');
                    $this.parent().removeClass('invalid');
                    $this.attr('aria-describedby', '');
                });

                //for select boxes
                $this.change(function () {
                    $this.removeClass('invalid');
                    $('label[for="' + id + '"]').removeClass('invalid');
                    $this.parent().removeClass('invalid');
                    $this.attr('aria-describedby', '');
                });
            });
        },

        /**
         * this regex matches
         * (+351) 282 43 50 50
         * 90191919908
         * 555-8909
         * 001 6867684
         * 001 6867684x1
         * 1 (234) 567-8901
         * 1-234-567-8901 x1234
         * 1-234-567-8901 ext1234
         * 1-234 567.89/01 ext.1234
         * 1(234)5678901x1234
         * (123)8575973
         * (0055)(123)8575973
         */
        validatePhoneNumber: function (field) {
            if (!this.validateInteger(field) || field.val().length < 5) {
                field.addClass('invalid');
                field.parent().addClass('invalid');
                var id = field.attr('id');
                field.attr('aria-describedby', id + '-error-msg');
                $('#' + id + '-error-msg-phone').removeClass('hide');
                return false;
            }

            field.removeClass('invalid');
            field.parent().removeClass('invalid');
            field.attr('aria-describedby', '');
            return true;
        },

        validateInteger: function (field) {
            var re = /^\+?-?[0-9]+$/;

            if (!re.test(field.val())) {
                field.addClass('invalid');
                field.parent().addClass('invalid');
                var id = field.attr('id');
                field.attr('aria-describedby', id + '-error-msg');
                $('#' + id + '-error-msg-number').removeClass('hide');
                return false;
            }

            field.removeClass('invalid');
            field.parent().removeClass('invalid');
            field.attr('aria-describedby', '');
            return true;
        },

        validateEmail: function (field) {
            var re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!re.test(field.val())) {
                field.addClass('invalid');
                field.parent().addClass('invalid');
                var id = field.attr('id');
                field.attr('aria-describedby', id + '-error-msg');
                $('#' + id + '-error-msg-email').removeClass('hide');
                return false;
            }

            field.removeClass('invalid');
            field.parent().removeClass('invalid');
            $('#' + id + '-error-msg-email').addClass('hide');
            field.attr('aria-describedby', '');
            return true;
        },

        /**
         * Validate required fields in a form (inline validation)
         * @param {object}  Form    Form object
         * @returns {boolean}
         */
        validateForm: function (Form) {
            var valid = true;
            FG.Base.resetErrors(Form);
            Form.find('.required:visible').each(function () {
                var $this = $(this),
                    id = $this.attr('id'),
                    val = $this.val(),
                    fieldValid = true;

                if (val == '' || val == null || val == undefined) {
                    fieldValid = false;
                }

                if (!fieldValid) {
                    $this.addClass('invalid');
                    Form.find('label[for="' + id + '"]').addClass('invalid');
                    $this.parent().addClass('invalid');
                    $('#' + id + '-error-msg').removeClass('hide');
                    $this.attr('aria-describedby', id + '-error-msg');
                }

                valid = fieldValid && valid;
            });
            if (!valid) {
                Form.find('input.invalid').first().focus();
            }
            return valid;
        },

        /**
         * Reset errors on a given form
         * @param {object}  Form    Form object
         */
        resetErrors: function (Form) {
            Form.find('.invalid').not('span').removeClass('invalid');
            Form.find('.controls-row.errors span').addClass('hidden');
            Form.find('.error-msg').addClass('hide');
        },

        /**
         * Return the current client side timestamp
         */
        getCurrentTimestamp: function () {
            return Math.round(new Date().getTime() / 1000);
        },

        /**
         * Get the label root
         * @returns {String}
         */
        getLabelRoot: function () {
            return this.labelRoot;
        },

        /**
         * Get the label name
         * @returns {String}
         */
        getLabelName: function () {
            return $('#labelName').val();
        },

        /**
         * Get the current environment we are in
         * @returns {String}
         */
        getEnvironment: function () {
            return this.environment;
        },

        /**
         * Convert newlines to breaks
         * @param {String}  str         String to replace
         * @param {Boolean} is_xhtml    Is this XHTML? i.e. <br/> vs <br>
         * @returns {string}
         */
        nl2br: function (str, is_xhtml) {
            var breakTag =
                is_xhtml || is_xhtml == undefined ? '<br />' : '<br>';
            return str.replace(
                /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
                '$1' + breakTag + '$2'
            );
        },

        /**
         * Set a job response and initialize the poller
         * @param {Object}  FGResponse  Standard FG response object
         * @return bool
         */
        setJobResponse: function (FGResponse) {
            var db = new FG.DB();
            db.set('jobId', FGResponse.jobId);
            db.set('wait', FGResponse.wait);
            db.set(
                'jobCheckTimestamp',
                this.getCurrentTimestamp() + FGResponse.wait
            ); //UNIX TS + wait (in seconds)
            return true;
        },

        /**
         * Poll a job and check for completeness
         * @return {Object} FGResponse  Completed response from the job passed via session
         */
        pollJob: function () {
            var self = this;

            var db = new FG.DB();

            var wait = db.get('wait');

            var intervalId = setInterval(function () {
                var Ajax = new FG.Ajax('job/check');

                Ajax.setSuccessCallback(function (FGResponse) {
                    self.setJobResponse(FGResponse);

                    //If this is not a job response, then clear the interval and return
                    if (FGResponse.wait == 0) {
                        window.clearInterval(intervalId);

                        return FGResponse;
                    } else {
                        window.location.reload();
                    }
                });

                Ajax.setFailureCallback(function (FGResponse) {
                    self.setJobResponse(FGResponse);
                });

                Ajax.send();
            }, wait * 1000);
        },
        /* Marks all visible required fields in the auth form with the 'invalid' class */
        markFormFieldsInvalid: function ($form) {
            $form.find('.required:visible').each(function () {
                var $field = $(this);
                var fieldId = $field.attr('id');
                var $label = $form.find('label[for="' + fieldId + '"]');
                $field.addClass('invalid');
                $label.addClass('invalid');
                $field.parent().addClass('invalid');
                $field.attr('aria-describedby', fieldId + '-error-msg');
            });
        },
        /**
         * Capture datastream parameters from URL query string and write them to cookies
         * Looks for specific marketing and tracking parameters in the URL
         */
        captureDatastreamData: function () {
            var datastreamKeys = ['RUID', 'PUID', 'fbclid', 'utm', 'utm_source', 'utm_medium', 'utm_campaign','twclid'];

            // Parse URL parameters
            var urlParams = new URLSearchParams(window.location.search);

            // Iterate through datastream keys and write matching parameters to cookies
            datastreamKeys.forEach(function(key) {
                if (urlParams.has(key)) {
                    var value = urlParams.get(key);
                    $.cookie(key, value, { path: '/' });

                    // Make PUID available to GTM tags via the dataLayer
                    if (key === 'PUID') {
                        dataLayer.push({ 'PUID': value });
                    }
                }
            });
        }
    };
})();
